module.exports = "<reusable-card \n  icon=\"settings\" \n  card-class=\"shared-card-component\">\n  \n  <card-content>\n    <h4>Option Data Management</h4>\n    <reusable-table\n      columns=\"$ctrl.columns\"\n      display-columns=\"$ctrl.displayColumns\"\n      data=\"$ctrl.optionTypes\"\n      enable-search=\"true\"\n      readonly=\"true\"\n      on-row-click=\"$ctrl.openOptionModal({item: item})\">\n    </reusable-table>\n  </card-content>\n  \n</reusable-card>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/options-manager/options-manager.html
// module id = 1388
// module chunks = 0